import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { forkJoin, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Globals } from "src/app/app.global-variable";
import { AuthState } from "src/app/store/auth";
import { selectAuthState } from "src/app/store/auth/auth.selectors";
import { SystemPropertyService } from "./system-services/system-property.service";
import { OrganisationAttributeService } from "./organisation-services/organistion-attribute.service";
import { DateTimeFormat, DateTimeFormatCodes } from "../constants/datetime-format-constants";
import { DateFormatsView } from "../views/date-formats-view"

@Injectable({
    providedIn: 'root'
})
export class DateTimeFormatService {
    private unsubscribe$ = new Subject();
    private ATTRIBUTETYPECODE_FIRSTDAYOFWEEK = "FIRSTDAYOFWEEK";
    constructor(private systemPropertyService: SystemPropertyService,
        private organisationAttributeService: OrganisationAttributeService,
        private globals: Globals,
        private store: Store<any>) {

    }

    public getDateTimeFormat(): string {
        return this.globals.DATETIME;
    }

    public getLongDateFormat(): string {
        return this.globals.LONGDATE;
    }

    public getShortDateFormat(): string {
        return this.globals.SHORTDATE
    }

    public getTimeFormat(): string {
        return this.globals.TIME;
    }

    public getInputDateFormat(): string {
        return this.globals.INPUTDATE ?? DateTimeFormat.IsoDate;
    }

    public getFirstDayOfWeek(): number {
        return this.globals.FIRSTDAYOFWEEK;
    }

    public getAllFormats(): DateFormatsView {
        return {
            dateTimeFormat: this.getDateTimeFormat(),
            longDateFormat: this.getLongDateFormat(),
            shortDateFormat: this.getShortDateFormat(),
            timeFormat: this.getTimeFormat(),
            inputDateFormat: this.getInputDateFormat()
        } as DateFormatsView;
    }

    public setGlobalDateTimeFormats() {
        this.store.select(selectAuthState)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
                (state: AuthState) => {
                    if (state.user) {
                        let attributeTypeCodes = DateTimeFormatCodes.join(',');

                        forkJoin({
                            dateTimeSystemProperties: this.systemPropertyService.getDateTimeSystemProperty(),
                            organisationAttributes: this.organisationAttributeService.getOrganisationAttributeHierarchy(attributeTypeCodes),
                            organisationAttributesFirstDayOfWeek: this.organisationAttributeService.getOrganisationAttributeHierarchy(this.ATTRIBUTETYPECODE_FIRSTDAYOFWEEK)
                        }).subscribe(({
                            dateTimeSystemProperties,
                            organisationAttributes,
                            organisationAttributesFirstDayOfWeek
                        }) => {
                            if (dateTimeSystemProperties?.length) {
                                for (let dateTimeSystemProperty of dateTimeSystemProperties) {
                                    this.globals[dateTimeSystemProperty.systemPropertyCode] = dateTimeSystemProperty.propertyText;
                                }
                            }
                            if (organisationAttributes?.length) {
                                for (let organisationAttribute of organisationAttributes) {
                                    this.globals[organisationAttribute.organisationAttributeTypeCode] = organisationAttribute.attributeChoiceName;
                                }
                            }
                            if (organisationAttributesFirstDayOfWeek?.length) {
                                this.globals.FIRSTDAYOFWEEK = organisationAttributesFirstDayOfWeek[0].attributeChoiceName;
                            }
                            return;
                        })
                        this.unsubscribe$.next();
                        this.unsubscribe$.unsubscribe();
                    }
                }
            )
    }
}